import styled from 'styled-components'

export const CardTitle = styled.div`
  font-size: var(--font-heading-extra-small);
  font-weight: var(--font-weight-semi-bold);
  margin-bottom: var(--size-medlarge);
  display: flex;
  align-items: center;
  text-transform: uppercase;
`

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
